import React from "react";
import { Route, Link, Routes } from "react-router-dom";
import "./index.css";
import Home from "./pages/User/Home.jsx";
import Admin from "./pages/Admin/Admin.jsx";
import DashBoard from "./pages/Admin/DashBoard.jsx";
import NotFound from "./pages/NotFound.jsx";
import Layout from "./components/Layout.jsx";
import BaptismInvite from "./pages/BaptismInvite.jsx";
import BaptismRecords from "./pages/BaptismRecords.jsx";
import BaptismLeaderboard from "./pages/BaptismLeaderboard.jsx";
import BaptismQuiz from "./pages/BaptismQuiz.jsx";
import BaptismQuizLobby from "./pages/BaptismQuizLobby.jsx";
import BaptismRaffle from "./pages/BaptismRaffle.jsx";
import BaptismGallery from "./pages/BaptismGallery.jsx";
import BaptismAdmin from "./pages/BaptismAdmin.jsx";
import BaptismAdminLogin from "./pages/BaptismAdminLogin.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import Codehouze from "./pages/Codehouze.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Codehouze />} />
        <Route path="/maxwell" element={
        <Layout><Home /></Layout>} />
        <Route path="/admin" element={<Layout>
          <Admin />
          </Layout>} />
        <Route path="/dashboard" element={<Layout>
          <DashBoard />
          </Layout>} />
        <Route path="/codehouze" element={<Codehouze />} />
        <Route path="/baptism" element={<BaptismInvite />} />
        <Route path="/baptism/mb" element={<BaptismRecords />} />
        <Route path="/baptism/leaderboard" element={<BaptismLeaderboard />} />
        <Route path="/baptism/quiz" element={<BaptismQuizLobby />} />
        <Route path="/baptism/quiz/:quizId" element={<BaptismQuiz />} />
        <Route path="/baptism/raffle" element={<BaptismRaffle />} />
        <Route path="/baptism/gallery" element={<BaptismGallery />} />
        <Route path="/baptism/admin/login" element={<BaptismAdminLogin />} />
        <Route path="/baptism/admin" element={<ProtectedRoute><BaptismAdmin /></ProtectedRoute>} />
        <Route path="*" element={<Layout>
          <NotFound />
          </Layout>} />
      </Routes>
    </>
  );
}

export default App;
